





import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { validateCuit, required } from '@/utils/ValidationUtil'
import { magistradoStore } from '@/store'
import Magistrado from '@/model/Magistrado'

@Component({
  components: {},
})
export default class CargaMagistrado extends Vue {
  $refs: {
    form: Vue & { validate(): boolean; resetValidation(): void; reset(): void }
  }

  @Prop({ default: false, type: Boolean })
  private disabled: boolean

  @Prop()
  private value: number | undefined

  @Prop()
  private nombreEntidad: string

  private magistrado: Magistrado | any = {}
  private cuil: number | undefined = 0
  private loading = false
  private valid = true
  private lazy = true
  private errorMessages: string[] = []
  private get integranteDesc() {
    return this.magistrado.apellido && this.magistrado.nombre
      ? `${this.magistrado.abreviacion} ${this.magistrado.apellido}, ${this.magistrado.nombre}`
      : ''
  }
  validateCuit(cuit: string) {
    return validateCuit(cuit)
  }
  validate() {
    return this.$refs.form.validate()
  }
  resetValidation() {
    return this.$refs.form.resetValidation()
  }
  reset() {
    return this.$refs.form.reset()
  }
  @Watch('value')
  updateValue() {
    this.cuil = this.value
  }
  private rules = {
    required,
  }
  @Watch('cuil')
  async updateCuil() {
    this.$emit('input', this.cuil)
    if (
      this.cuil?.toString().length === 11 &&
      validateCuit(this.cuil) === true
    ) {
      try {
        this.loading = true
        this.magistrado = await magistradoStore.load(this.cuil)
      } catch (error) {
        this.magistrado = {}
        this.errorMessages = [error]
      } finally {
        this.loading = false
      }
    } else {
      this.clearComponent()
    }
  }
  private clearComponent() {
    this.magistrado = {}
    this.errorMessages = []
  }
  beforeDestroy() {
    this.clearComponent()
  }
}
